export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_763_CLOSE': 'Close',
    '__INTELLIGENT_COACH_ASSIST_GPS': 'Intelligent Coach Assist GPS',
    '__MINIMIZE': 'Minimize',
    '__MAXIMIZE': 'Maximize',
};
